export default __webpack_public_path__ + "static/media/16.8023d87e.svg";